import _GalleryOptions from './ProGallery.options.json';
import _GallerySections from './ProGallery.sectionOptions.json';
import _GalleryOptionsGen from './ProGallery.autoGeneratedOptions.json';
// @ts-expect-error
delete _GalleryOptions.$schema;

// @ts-expect-error
delete _GallerySections.$schema;

// @ts-expect-error
delete _GalleryOptionsGen.$schema;
export const ProGalleryOptions = {
  ..._GalleryOptions,
  ..._GalleryOptionsGen
};
export const ProGallerySettingsOptions = {
  ...ProGalleryOptions,
  ..._GallerySections,
  ..._GalleryOptionsGen
};
const pgDefaultOptions = {
  ...Object.values(ProGalleryOptions).reduce((defaults, option) => ({
    ...defaults,
    [option.key]: option.default
  }), {})
};
export const processProGalleryOptions = options => ({
  ...pgDefaultOptions,
  ...options
});
//# sourceMappingURL=ProGallery.options.js.map